import { useEffect } from 'react'

import { useSettings } from '@queries/settings'

export const CookiebotScript = () => {
  const [{ cookiesConsent }] = useSettings()

  useEffect(() => {
    const cbid = cookiesConsent.configuration?.cbid

    if (!cbid) return
    /* istanbul ignore next */
    if (document.getElementById('Cookiebot')) return

    const script = document.createElement('script')
    script.id = 'Cookiebot'
    script.src = 'https://consent.cookiebot.com/uc.js'
    script.setAttribute('data-cbid', cbid)
    script.setAttribute('data-blockingmode', 'auto')
    script.type = 'text/javascript'

    document.head.appendChild(script)

    /* istanbul ignore next */
    return () => {
      const existingScript = document.getElementById('Cookiebot')
      if (existingScript) {
        existingScript.remove()
      }
    }
  }, [cookiesConsent.configuration])

  return null
}
